// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"8e65b495","249":"b2d7ea82","297":"653bd96b","344":"fbe3e9b3","389":"063919ad","861":"8d862cfc","943":"c8de22f6","995":"91436949"}[chunkId] + ".chunk.js";
};